import {
  TOKEN_KEY,
} from './constants';
import { $fetch } from './fetch';

const AUTH_CODE = [100005, 400200];
const base = `${window.location.protocol}//${window.location.host}`;

// 从浏览器中获取 Token
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isAuthFailedCode = (code: number) => AUTH_CODE.includes(code);

// OAuth 回调地址：站点 /login，并携带登录前来源路径 from
export const buildRedirectUri = (from: string) => {
  return `${base}/login?from=${encodeURIComponent(from)}`;
};

export const gotoLogin = async (from = '/') => {
  const redirectUri = buildRedirectUri(from);

  // 调后端拿 OAuth 跳转地址，再跳转
  const { isSuccess, data } = await $fetch<{ auth_url: string; state: string }>('/api/auth/login', {
    data: { redirect_uri: redirectUri },
  });

  if (isSuccess && data?.auth_url) {
    window.location.replace(data.auth_url);
  }
};

export const isLogin = () => {
  if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
    return true;
  }
  else {
    return !!getToken();
  }
};
